import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Globe2 } from "lucide-react";
import IAVisitingIndiaArticle from "../components/india/IAVisitingIndiaArticle";
import IAPromoStrip from "../components/india/IAPromoStrip";
import IALangBar from "../components/india/IALangBar";

const TITLE = "Visiting India: Complete Guide for Foreign Travelers — IndianAirports.com";
const DESC = "Visa rules, e-Visa categories, e-Arrival Card, FRRO registration, Indian missions abroad, customs, safety, scams to avoid, transportation and responsible travel in India. Updated September 2026.";

/* Standalone SEO page for the Visiting India guide (Travel to India section). */
export default function IndiaVisitingGuide() {
  useEffect(() => {
    document.title = TITLE;
    const meta = document.querySelector('meta[name="description"]') || (() => {
      const m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); return m;
    })();
    const prevDesc = meta.content;
    meta.content = DESC;

    const canonical = document.createElement("link");
    canonical.rel = "canonical";
    canonical.href = `${window.location.origin}/india/guides/visiting-india`;
    document.head.appendChild(canonical);

    const ld = document.createElement("script");
    ld.type = "application/ld+json";
    ld.textContent = JSON.stringify({
      "@context": "https://schema.org", "@type": "Article",
      headline: "Visiting India: A Complete Guide for Foreign Travelers",
      dateModified: "2026-09-01", inLanguage: "en",
      author: { "@type": "Organization", name: "IndianAirports.com" },
      publisher: { "@type": "Organization", name: "IndianAirports.com" },
      mainEntityOfPage: `${window.location.origin}/india/guides/visiting-india`,
    });
    document.head.appendChild(ld);

    window.scrollTo(0, 0);
    return () => { meta.content = prevDesc; canonical.remove(); ld.remove(); };
  }, []);

  return (
    <div data-testid="india-visiting-guide-page">
      <div className="bg-gradient-to-br from-orange-50 via-white to-sky-50 border-b border-zinc-200">
        <div className="max-w-4xl mx-auto px-5 py-8">
          <Link to="/india/guides" className="text-xs font-700 text-blue-700 inline-flex items-center gap-1 hover:underline" data-testid="india-visiting-guide-back">
            <ArrowLeft className="w-3.5 h-3.5" /> Travel to India guides
          </Link>
          <p className="mt-2 text-xs font-800 uppercase tracking-wide text-orange-700 inline-flex items-center gap-1.5"><Globe2 className="w-3.5 h-3.5" /> Travel to India</p>
          <h1 className="mt-1 font-heading font-900 text-4xl sm:text-5xl tracking-tight" data-testid="india-visiting-guide-title">
            Visiting India: A Complete Guide for Foreign Travelers
          </h1>
          <p className="mt-2 text-base text-zinc-600 max-w-2xl">
            Visas, arrival requirements, missions abroad, customs, safety and respectful travel — with section-by-section audio.
          </p>
          <div className="mt-4"><IALangBar /></div>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-5 py-8 space-y-10">
        <IAVisitingIndiaArticle />
        <IAPromoStrip city="India" />
      </div>
    </div>
  );
}
